import type { FaireProductEntity } from "../../entity_types/product";

export const atc_goes_well_3: FaireProductEntity = {
  token: "atc_goes_well_3",
  type: "product",
  name: "Silentium Reed Diffuser",
  brandName: "Vancouver Candle Co",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/43dce5f9a2b443c860c6afe8944bdb6195d82329c3f230bfebe98bdfc6015a84.webp",
  priceDollars: 28,
  msrpDollars: 56,
  description: "Recommended accessory for ATC flow.",
  tags: ["goes-well-with", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
